import Moment from "react-moment"
import { Link, useOutletContext } from "react-router-dom";
import Withdraw from "../components/Svg/Withdraw"
import NotVisible from "../components/Svg/NotVisible"
import Visible from "../components/Svg/Visible"
import CopyIcon from "../components/Svg/CopyIcon"
import DTransactions from "../components/DTransactions";
import { useState } from "react";
import TransactionIcon from "../components/Svg/TransactionIcon";
import EmptyTransaction from "../components/EmptyTransaction";
import DashboardHeader from "../components/DashboardHeader"

function UserDashboard() {
    const date= new Date();
    const [showBalance, setshowBalance] = useState(false)
    const [paylink, Bal, username, fullname, trans] = useOutletContext() 
    const [copylink, setCopylink] = useState('Copy');
    const Balance= () => {
      return Bal.toFixed(2);
    } 
  
    const handleShowBalance = (e) => {
       !showBalance && setshowBalance(true)
    }
    const handleHideBalance = (e) => {
       showBalance && setshowBalance(false)
    }

const copyToClipBoard = async (paylink) => {
    try {
      await navigator.clipboard.writeText(paylink);
      setCopylink('Copied')
    }catch(err){
      setCopylink('Failed to Copy')
    }
}

    const handleCopy = (e) => {
      copyToClipBoard(paylink)
    }

  return (
   <> 
     <DashboardHeader title="Dashboard" profilename={fullname}/>
    <div className="dashboard-content-top">
          <div className="content-top-left">
          <h4 className="greet-user">
            Hello, {fullname} 👋
          </h4>
          <Moment className="dashboard-date" format="dddd, MMMM Do, YYYY">{date}</Moment>
          </div>
          <div className="content-top-right">
            <Link className="withdraw-group" to="../withdraw">
              <Withdraw className="withdraw-icon" fill="#60B0F4" />
              Withdraw Funds
            </Link>
          </div>
        </div>
        <div className="dashboard-card">
          <div className="dc-top">
            <p className="dc-username">@{username}</p>
            {showBalance ? <div className="not-visible-group" onClick={handleHideBalance}><NotVisible className="not-visible-icon" stroke="white" /></div> : <div className="visible-group" onClick={handleShowBalance}><Visible className="visible-icon" fill="white" /></div>  }
          </div>
          <div className="hr"></div>
        <h1 className="dc-title">Payourl Available Balance</h1>
      {showBalance ?  <h3 className="dc-amt"> ₦{Balance()}</h3> :  <h3 className="dc-amt"> ₦********</h3>}
        </div>
        <div className="dc-bottom-right">
        <Link className="withdraw-group" to="../withdraw">
          <Withdraw className="withdraw-icon" fill="#60B0F4" />
          Withdraw Funds
        </Link>
      </div>
      <div className="dashboard-link-group">
        <p className="pay-link"> {paylink} </p>
        <div className="copy-icon-group" onClick={handleCopy}>
        <CopyIcon className="copy-icon" fill="#60B0F4" />
        <p className="link-msg">{copylink}</p>
        </div>
      </div>
      <div className="db-transactions">
      <h5 className="trans-head db-trans-head">Recent Transactions</h5>
      {trans.length ? <DTransactions trans={trans} /> : <EmptyTransaction />}
        <div className={trans ? "view-trans-group" : "d-none"}>
            <Link className="view-trans-link" to="../recent-transactions">
                <TransactionIcon classsName="trans-icon" fill="#60B0F4" />
                View Transactions
            </Link>
        </div>
      </div>
   </>
  )
}

export default UserDashboard